import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { LoadingIndicator } from "@digital-services/ui";

interface Props {
  message?: string;
}

// TBD replace and then remove
const LoadingComponent: FunctionComponent<Props> = ({ message }) => {
  const { t } = useTranslation();

  return (
    <div className="flex w-full items-center text-base">
      <LoadingIndicator label={message ?? t("load.message")} />
    </div>
  );
};

export default LoadingComponent;
